
import { Component, Vue, Prop } from "vue-property-decorator";
import { Credential } from "@/graph/servicecloud/credentials";
import graph from "@/graph";

@Component
export default class CredentialEdit extends Vue
{
	@Prop(String) readonly credentialkey: string | undefined;
	@Prop({ default: true }) readonly visible!: boolean;

	currentKey = "";

	loading = true;
	saving = false;
	saveButtonText = "Save";
	credData: Credential | null = null;
	newCred: {key: string, value: string}[] = [{
		key: "",
		value: "",
	}];

	async saveCred()
	{
		console.log("CredentialEdit saveCred", this.credData);

		this.saving = true;
		this.saveButtonText = "Saving ...";

		console.log(this.credData);

		if(this.credData)
		{
			const key = this.credData.key;

			if(this.credData.data)
			{
				const data = this.credData.data;

				const result = await graph.servicecloud.credentials.updateCredential(key, data);
				console.log("CredentialEdit saveCred", "result", result);
			}
		}

		this.saving = false;
		this.saveButtonText = "Save";
	}

	addRow()
	{
		console.log(this.newCred);
		if(this.newCred[0] && this.credData)
		{
			if(!this.credData.data)
			{
				this.credData.data = [];
			}

			this.credData.data.push({
				key: this.newCred[0].key,
				value: this.newCred[0].value,
				type: "STRING",
			});

			this.newCred[0].key = "";
			this.newCred[0].value = "";
		}
	}

	updated()
	{
		console.log("CredentialEdit updated", "userkey", this.credentialkey, "visible", this.visible, "currentkey", this.currentKey);

		if(this.visible == true && this.credentialkey !== "" && this.credentialkey !== this.currentKey)
		{
			this.loadData();
		}
	}

	activated()
	{
		console.log("CredentialEdit activated", this.credentialkey);
	}

	async loadData()
	{
		this.currentKey = this.credentialkey ?? "";
		this.loading = true;
		const result = await graph.servicecloud.credentials.get(this.credentialkey ?? "");
		
		if(result.length > 0)
		{
			const cred = result.pop();

			if(cred)
			{
				this.credData = cred;
			}
		}

		this.loading = false;
	}

	mounted()
	{
		console.log("CredentialEdit mounted", "userkey", this.credentialkey, "visible", this.visible, "currentkey", this.currentKey);

		if(this.visible == true && this.credentialkey !== "" && this.credentialkey !== this.currentKey)
		{
			this.loadData();
		}
	}

	
}
